export default {
  TASK: 'Task',
  TASKS: 'Tasks',
  TASKS_ASSIGNEE: 'Assignee',
  TASKS_CONFIRM_DELETE: 'Are you sure you want to delete this task?',
  TASKS_CONSTITUENT: 'Constituent',
  TASKS_COUNT: '{count, plural, =1 {1 task} other {# tasks}}',
  TASKS_CREATE_ERROR:
    'There was a problem creating your task. Please try again.',
  TASKS_CREATE_SUCCESS: 'Your task has been created',
  TASKS_CREATE_TASK: 'Create Task',
  TASKS_DATE: 'Due Date',
  TASKS_DELETE_SUCCESS: 'Your task has been deleted',
  TASKS_DELETE_ERROR:
    'There was a problem deleting your task. Please try again.',
  TASKS_DUE_DATE: 'Due Date',
  TASKS_EDIT_TASK: 'Edit Task',
  TASKS_NOTES: 'Notes',
  TASKS_TASK_NAME: 'Task Name',
  TASKS_UPDATE_SUCCESS: 'Your task has been updated',
  TASKS_UPDATE_ERROR:
    'There was a problem updating your task. Please try again.',
  TASKS_VALIDATION_CREATE_TITLE_REQUIRED: 'Add a task name to create',
  TASKS_VALIDATION_EDIT_TITLE_REQUIRED: 'Add a task name to update',
  TASKS_MARK_AS_COMPLETE: 'Mark as complete',
  TASKS_MARK_AS_INCOMPLETE: 'Mark as incomplete',
  TASKS_NO_TASKS: 'No tasks here.',
  TASKS_CLICK_TO_CREATE: 'Click below to create one.',
  TASKS_MY_TASKS: 'My Tasks',
  TASKS_ORG_TASKS: 'Tasks in Org',
  TASKS_CAUGHT_UP: "You're all caught up!",
  TASKS_INCOMPLETE: 'Incomplete Tasks',
  TASKS_COMPLETE: 'Complete Tasks',
  TASKS_ALL: 'All Tasks',
  TASKS_CREATION_TIME: 'Date Created',
  TASKS_FILTER_LIST: 'Filter Task List',
  TASKS_UPDATE_LIST: 'Update List',
  TASKS_FETCH_ERROR: 'There was a problem fetching tasks.',
  TASKS_COUNT_OPEN: '{count} open',
  TASKS_COUNT_OVERDUE: '{count} overdue',
};
